module.exports = __webpack_public_path__ + "static/img/ic_home_active.6da17ef2.png";